import { render } from "./HomBlocosHomeView.vue?vue&type=template&id=1fdd6856&scoped=true"
import script from "./HomBlocosHomeView.vue?vue&type=script&lang=js"
export * from "./HomBlocosHomeView.vue?vue&type=script&lang=js"

import "./HomBlocosHomeView.vue?vue&type=style&index=0&id=1fdd6856&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdd6856"]])

export default __exports__